var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 11.0013C19.4798 17.5183 12.5198 11.7327 11.0007 14.7758C10.0585 16.6631 13.6643 19.0221 11.0007 19.0221C6.31774 19.0221 2.52148 15.4311 2.52148 11.0013C2.52148 6.57152 6.31774 2.98047 11.0007 2.98047C15.6835 2.98047 19.4798 6.57152 19.4798 11.0013Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 7.10286C10.5417 7.73569 10.0287 8.2487 9.39583 8.2487C8.763 8.2487 8.25 7.73569 8.25 7.10286C8.25 6.47003 8.763 5.95703 9.39583 5.95703C10.0287 5.95703 10.5417 6.47003 10.5417 7.10286Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79167 11.0013C7.79167 11.6342 7.27866 12.1471 6.64583 12.1471C6.013 12.1471 5.5 11.6342 5.5 11.0013C5.5 10.3684 6.013 9.85547 6.64583 9.85547C7.27866 9.85547 7.79167 10.3684 7.79167 11.0013Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1257 8.47786C15.1257 9.11069 14.6127 9.6237 13.9798 9.6237C13.347 9.6237 12.834 9.11069 12.834 8.47786C12.834 7.84503 13.347 7.33203 13.9798 7.33203C14.6127 7.33203 15.1257 7.84503 15.1257 8.47786Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/color-palette.5cc8016268e78b75a32a7d9545549339.svg";
export { ForwardRef as ReactComponent };